import * as actionTypes from '../actions/actionTypes';

const initialState = {
  userDetails: null
};

const authenticationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_SUCCESS_LOGIN:
      return {
        ...state,
        userDetails: action.userDetails
      }
    case actionTypes.LOGOUT:
      localStorage.removeItem("country");
      return {
        ...state,
        userDetails: null
      }
    case actionTypes.CHANGE_PASSWORD_SUCCESSFUL:
      return {
        ...state,
        userDetails: action.userDetails
      }
    default:
      return state;
  }
}

export default authenticationReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/authenticationReducer.js